module.exports = __webpack_public_path__ + "static/media/GA.27e58be6.png";